var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticStyle: {
      "background-image": "url(static/assets/images/footer.png)"
    },
    attrs: {
      "id": "footer"
    }
  }, [_c('div', {
    staticClass: "container"
  }, [(_vm.instanceName !== 'MAHADEMY') ? _c('div', {
    staticClass: "row align-items-center"
  }, [_c('div', {
    staticClass: "col-lg-6 copyright"
  }, [_vm._v("\n                © " + _vm._s(_vm.$t('footer.copyright')) + " " + _vm._s(_vm.getCurrentYear) + " " + _vm._s(_vm.$t('footer.mkcl_title'))), _c('br'), _vm._v("\n                " + _vm._s(_vm.$t('footer.rights_reserved')) + "\n            ")]), _vm._v(" "), _vm._m(0)]) : _c('div', [_c('div', {
    staticClass: "col-lg-12 "
  }, [_vm._v("\n               " + _vm._s(_vm.$t('footer.mahademy_title')) + "  © " + _vm._s(_vm.$t('footer.copyright')) + " " + _vm._s(_vm.getCurrentYear) + " " + _vm._s(_vm.$t('footer.mkcl_title')) + "\n            ")])])]), _vm._v(" "), _c('back-to-top', {
    attrs: {
      "visibleOffset": "600",
      "bottom": "30px"
    }
  }, [_c('button', {
    staticClass: "btn btn-to-top",
    attrs: {
      "type": "button"
    }
  }, [_c('i', {
    staticClass: "mdi mdi-chevron-up"
  })])])], 1)
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-lg-6 olinks"
  }, [_c('ul')])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4cd0a41f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/footerArea.vue
// module id = PK6y
// module chunks = 1